export interface NavItem {
  label: string;
  path: string;
}

export interface SocialLink {
  name: string;
  icon: string;
  url: string;
}

export const navItems: NavItem[] = [
  { label: "首页", path: "/" },
  { label: "资讯", path: "/news" },
  { label: "作品", path: "/works" },
  { label: "个人资料", path: "/profile" },
  { label: "联系", path: "/contact" },
];

export const footerWorkLinks: NavItem[] = [
  { label: "全部作品", path: "/works" },
  { label: "影视作品", path: "/works/movies" },
  { label: "音乐作品", path: "/works/music" },
];

export const socialLinks: SocialLink[] = [
  { name: "微博", icon: "ri-weibo-fill", url: "https://ka-chao.cn/weibo" },
  { name: "微信", icon: "ri-wechat-fill", url: "https://ka-chao.cn/wechat" },
  { name: "视频平台", icon: "ri-video-fill", url: "https://ka-chao.cn/video" },
  { name: "音乐平台", icon: "ri-music-2-fill", url: "https://ka-chao.cn/music" },
];

export const siteIntro = {
  name: "森泽佳奈",
  subtitle: "个人品牌官方网站",
  description:
    "这里汇集森泽佳奈的最新动态、个人资料与影视音乐作品。网站以权威、专业、清晰为目标，帮助粉丝、媒体与文化爱好者一站式了解她的艺术成就与成长轨迹。",
  highlights: [
    { value: "10+", label: "影视作品" },
    { value: "3", label: "个人专辑" },
    { value: "2021", label: "出道年份" },
    { value: "5", label: "巡演城市" },
  ],
};

export const contactInfo = {
  email: "contact@senzhuang-jiana.demo",
  weibo: "weibo.com/senzhuangjiana",
  address: "东京都 · 涩谷区（演示地址）",
  notice:
    "本网站为演示性质的作品展示页面，所有内容、数据与联系方式均为虚构示例，不代表任何真实人物或机构。请勿用于商业用途。",
};